<template>
  <div>retrievepwd</div>
</template>
<script>
import { mapGetters } from 'vuex'
import LockScreen from '@/components/LockScreen'
import fetch from '@/api/httpFetch.js'
import { allToggleClass } from '@/utils'
 import {rServiceValidate,getResourceMenu } from "@/api/bizApi/commonUtil";
// import secret from '../../../secret/secret.js'
export default {
  data() {

    let options={
    }

    return options 
  },
  components: {

  },
  
  computed: {

  },
  watch: {

  },
  methods: {

  },
  created() {
    window.location.href=window.LOCAL_CONFIG.RETRIEVEPWD
  
  },
  mounted() {

   
  }
}

</script>




// WEBPACK FOOTER //
// src/views/retrievepwd.vue